/**
 * Application configuration
 * This file contains configuration settings for the application
 */

// Logo configuration
export const logoConfig = {
  // Path to the logo image (can be jpg, png, or webp)
  // This path is relative to the public directory
  path: "/logo.png",

  // Alternative text for the logo
  alt: "Repair Shop Logo",

  // Logo dimensions
  width: 120,
  height: 120,
};

export const logoPrintConfig = {
  // Path to the logo image (can be jpg, png, or webp)
  // This path is relative to the public directory
  path: "/logo-print.png",

  // Alternative text for the logo
  alt: "Repair Shop Logo",

  // Logo dimensions
  width: 120,
  height: 120,
};

// App configuration
export const appConfig = {
  // Company/app name
  name: "Beunlocker",

  // Default currency
  currency: "TND",

  // Store prefix for QR codes (used in Talifouni app)
  // Format: PREFIX + ticket number (e.g., BUN12345)
  storePrefix: import.meta.env.VITE_STORE_PREFIX || "BUN",

  // Other app-wide settings can be added here
};
